/**
 * Vipps payment fee calculation utilities
 * Vipps charges 2.99% + 1 kr per transaction
 */

export const VIPPS_FEE_PERCENTAGE = 0.0299; // 2.99%
export const VIPPS_FEE_FIXED = 1; // 1 kr

/**
 * Calculate the Vipps fee for a given amount
 * @param amount - The gross amount in NOK
 * @returns The fee amount in NOK
 */
export function calculateVippsFee(amount: number): number {
  return Math.round((amount * VIPPS_FEE_PERCENTAGE + VIPPS_FEE_FIXED) * 100) / 100;
}

/**
 * Calculate the net amount after Vipps fee
 * @param grossAmount - The gross amount in NOK
 * @returns The net amount after fee in NOK
 */
export function calculateNetAmount(grossAmount: number): number {
  const fee = calculateVippsFee(grossAmount);
  return Math.round((grossAmount - fee) * 100) / 100;
}

/**
 * Calculate the gross amount needed to receive a specific net amount
 * @param netAmount - The desired net amount in NOK
 * @returns The gross amount needed in NOK
 */
export function calculateGrossAmount(netAmount: number): number {
  // Formula: gross = (net + fixed_fee) / (1 - percentage)
  return Math.ceil(((netAmount + VIPPS_FEE_FIXED) / (1 - VIPPS_FEE_PERCENTAGE)) * 100) / 100;
}

/**
 * Format a fee breakdown for display
 * @param grossAmount - The gross amount in NOK
 * @returns Object with formatted strings for display
 */
export function formatFeeBreakdown(grossAmount: number) {
  const fee = calculateVippsFee(grossAmount);
  const netAmount = calculateNetAmount(grossAmount);
  
  return {
    gross: `${grossAmount.toLocaleString('nb-NO')} kr`,
    fee: `${fee.toLocaleString('nb-NO')} kr`,
    net: `${netAmount.toLocaleString('nb-NO')} kr`,
    feePercentage: `${(VIPPS_FEE_PERCENTAGE * 100).toFixed(2)}%`,
    feeFixed: `${VIPPS_FEE_FIXED} kr`,
  };
}

